import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import API from '../../api';
import { toast } from 'react-toastify';

const NotificationsTab = () => {
  const { user } = useAuth();
  const [prefs, setPrefs] = useState({
    orderUpdates: true,
    promoEmails: true,
    backInStock: true,
    priceDrop: true,
  });
  const [saving, setSaving] = useState(false); // eslint-disable-line no-unused-vars

  useEffect(() => {
    if (user?.notificationPreferences) {
      setPrefs({
        orderUpdates: user.notificationPreferences.orderUpdates ?? true,
        promoEmails: user.notificationPreferences.promoEmails ?? true,
        backInStock: user.notificationPreferences.backInStock ?? true,
        priceDrop: user.notificationPreferences.priceDrop ?? true,
      });
    }
  }, [user]);

  const handleToggle = async (key) => {
    const newValue = !prefs[key];
    setPrefs((prev) => ({ ...prev, [key]: newValue }));

    try {
      // Auto-save on toggle
      await API.put('/api/auth/preferences', {
        notificationPreferences: { ...prefs, [key]: newValue }
      });
      // Optionally update local storage
      const stored = JSON.parse(localStorage.getItem('poshe_user') || '{}');
      if (stored) {
         stored.notificationPreferences = { ...prefs, [key]: newValue };
         localStorage.setItem('poshe_user', JSON.stringify(stored));
      }
    } catch (err) {
      toast.error('Failed to update preferences');
      // Revert on fail
      setPrefs((prev) => ({ ...prev, [key]: !newValue }));
    }
  };

  const prefDetails = [
    { key: 'orderUpdates', label: 'Order Updates', desc: 'Get SMS and email notifications about your order status.' },
    { key: 'promoEmails', label: 'Promotions & Offers', desc: 'Receive exclusive discounts and early access to sales.' },
    { key: 'backInStock', label: 'Back in Stock Alerts', desc: 'Be the first to know when your favorites are back.' },
    { key: 'priceDrop', label: 'Price Drop Alerts', desc: 'Get notified when prices drop on items you are tracking.' },
  ];

  return (
    <div className="p-6 md:p-8">
      <h2 className="font-playfair text-2xl font-bold text-navy mb-6">Notification Preferences</h2>
      
      <div className="space-y-6 max-w-2xl">
        {prefDetails.map((item) => (
          <div key={item.key} className="flex items-start justify-between gap-4 p-4 rounded-xl border border-gray-100 hover:border-gray-200 transition-colors bg-gray-50/50">
            <div>
              <h3 className="font-semibold text-charcoal">{item.label}</h3>
              <p className="text-sm text-gray-500 mt-1">{item.desc}</p>
            </div>
            <button 
              onClick={() => handleToggle(item.key)}
              className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none ${prefs[item.key] ? 'bg-green-500' : 'bg-gray-200'}`}
            >
              <span className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${prefs[item.key] ? 'translate-x-5' : 'translate-x-0'}`} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NotificationsTab;
